import config from '../config/config.json';

class ConfigService {
  constructor() {
    this.config = config;
  }

  getApiUrl() {
    return this.config.apiUrl;
  }

  getClientPersonTypeCode() {
    return this.config.ClientPersonTypeCode;
  }

  getAdminPersonTypeCode() {
    return this.config.AdminPersonTypeCode;
  }

  getSellerPersonTypeCode() {
    return this.config.SellerPersonTypeCode;
  }

  getDefaultNumberOfItemsTable() {
    return this.config.DefaultNumberOfItemsTable;
  }

  getDefaultNumberOfItemsTableClient() {
    return this.config.DefaultNumberOfItemsTableClient;
  }

  getOrderStatusWaitPayment() {
    return this.config.WaitPayment;
  }

  getOrderStatusPaid() {
    return this.config.Paid;
  }

  getOrderStatusCanceledCustomer() {
    return this.config.CanceledCustomer;
  }

  getOrderStatusCanceledStore() {
    return this.config.CanceledStore;
  }

  getOrderStatusExpired() {
    return this.config.Expired;
  }

  getOrderStatusUnderAnalysis() {
    return this.config.UnderAnalysis;
  }

  getOrderDescription(status) {
    var toReturn = '';
    switch(status){
      case this.getOrderStatusWaitPayment():
        toReturn = "Aguardando Pagamento";
        break;
      case this.getOrderStatusPaid():
        toReturn = "Pago";
        break;
      case this.getOrderStatusCanceledCustomer():
        toReturn = "Cancelado Cliente";
        break;
      case this.getOrderStatusCanceledStore():
        toReturn = "Cancelado Loja";
        break;
      case this.getOrderStatusExpired():
        toReturn = "Expirado";
        break;
      default:
        toReturn = "Em análise";
        break;
    }

    return toReturn;
  }

  getOrderAllowPayment(status) {
    var toReturn = '';
    switch(status){
      case 0:
        toReturn = "Não Permite";
        break;
      case 1:
        toReturn = "Permite pagamento";
        break;
      default:
        toReturn = "Em análise";
        break;
    }

    return toReturn;
  }

  getIsDigital(isDigital) {
    var toReturn = '';
    switch(isDigital){
      case 1:
        toReturn = "Digital";
        break;
      default:
        toReturn = "Físico";
        break;
    }

    return toReturn;
  }

  getPersonType(personType) {
    var toReturn = '';
    switch(personType){
      case 1:
        toReturn = "Física";
        break;
      case 2:
        toReturn = "Jurídica";
        break;
      case 3:
        toReturn = "Estrangeiro";
        break;
      default:
        toReturn = "Tranding";
        break;
    }

    return toReturn;
  }
}


var configService =  new ConfigService();
export default configService;
